var BANK_ID_ERROR;
(function(BANK_ID_ERROR2) {
  BANK_ID_ERROR2["ACCESS_DENIED"] = "bank-id.error.trustly";
  BANK_ID_ERROR2["SIMILAR_USER_EXISTS"] = "bank-id.error.exists";
  BANK_ID_ERROR2["PASSWORD_HAS_ALREADY_BEEN_SET"] = "bank-id.error.exists";
  BANK_ID_ERROR2["PERSONID_ALREADY_ASSIGNED"] = "bank-id.error.exists";
  BANK_ID_ERROR2["A009"] = "bank-id.error.funds";
  BANK_ID_ERROR2["A011"] = "bank-id.error.currency";
  BANK_ID_ERROR2["A013"] = "bank-id.error.deposit";
})(BANK_ID_ERROR || (BANK_ID_ERROR = {}));
var BANK_ID_PROVIDER;
(function(BANK_ID_PROVIDER2) {
  BANK_ID_PROVIDER2["TRUSTLY"] = "trustly";
  BANK_ID_PROVIDER2["GII"] = "gii-bankid-se";
})(BANK_ID_PROVIDER || (BANK_ID_PROVIDER = {}));
var BANK_ID_STEPS;
(function(BANK_ID_STEPS2) {
  BANK_ID_STEPS2["STEP1"] = "1";
  BANK_ID_STEPS2["STEP2"] = "2";
  BANK_ID_STEPS2["STEP3"] = "3";
  BANK_ID_STEPS2["DONE"] = "DONE";
})(BANK_ID_STEPS || (BANK_ID_STEPS = {}));

export { BANK_ID_ERROR, BANK_ID_PROVIDER, BANK_ID_STEPS };
